import { render, staticRenderFns } from "./commentDialog.vue?vue&type=template&id=57494fa6&scoped=true"
import script from "./commentDialog.vue?vue&type=script&lang=ts"
export * from "./commentDialog.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./commentDialog.vue?vue&type=style&index=0&id=57494fa6&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "57494fa6",
  "bf81f4a6"
  
)

export default component.exports